import apiCaller from '../../utils/apiCaller';
import urlHelper from '../../utils/url';
import errorHandler from '../Common/ErrorHandler';

export const AISTATS_LOADING = 'AISTATS_LOADING',
  AISTATS_LIST = 'AISTATS_LIST';

export function handleError(error) {
  return errorHandler.setError(error);
}

export function getAiStats(opt = {}) {
  return (dispatch) => {
    dispatch({ type: AISTATS_LOADING });

    let url = 'aistats';
    url += urlHelper.buildQuery(opt);

    apiCaller
      .api(url, 'get')
      .then((res) => {
        dispatch({
          type: AISTATS_LIST,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch(errorHandler.setError(err));
      });
  };
}
